<template>
  <!-- ================= HEADER ================= -->
  <header class="main-header">
    <div class="header-inner">

      <!-- LEFT -->
      <div class="header-left">

        <!-- Mobile Menu Toggle -->
        <button class="menu-btn md:hidden" @click="isMobileMenuOpen = true">
          <i class='bx bx-menu'></i>
        </button>

        <!-- Brand -->
        <div class="brand">
          <img src="/images/logo.png" style="height: 2.5rem;">
        </div>

        <!-- Desktop Nav -->
        <nav class="nav hidden md:flex">
          <a v-for="item in nav" :key="item.title" :href="item.path" :class="item.path === selPage ? 'active' : ''">
            {{ item.title }}
          </a>
        </nav>
      </div>

      <!-- RIGHT -->
      <div class="header-right">

        <!-- Plan (desktop only) -->
         <a href="javascript:void(0)" @click="gotoplans()">
        <div class="plan-pill hidden md:flex" v-if="ldata!=null && ldata.user_type!=='admin' && ldata.user_type!=='audience' && ldata.user_type!=='agancy'"
        >
          <span class="dot"></span>
          <span class="plan-text">Active Plan: {{ plan.name }}</span>
          <span class="divider"></span>
          <span class="renew">Renews {{ plan.renewal }}</span>
        </div>
        </a>

        <!-- Notifications -->
        <button class="icon-btn" @click="gotonoti()">
          <i class='bx bx-bell'></i>
        </button>

        <!-- Avatar -->
        <!-- <div class="avatar">
          <img :src="user.avatar" />
        </div> -->
        <!-- Avatar + Menu -->
        <div class="relative flex items-center gap-3">

          <!-- Avatar -->
          <!-- <div class="avatar cursor-pointer" @click="toggleUserMenu">
            <img src="images/uplace.jpg" />
          </div> -->
          <div class="avatar cursor-pointer icon-avatar" @click="toggleUserMenu">
            <i class='bx bx-user'></i>
          </div>
          <!-- User Text Info -->
          <div class="user-meta" v-if="ldata" @click="toggleUserMenu">
            <div class="uname">{{ ldata.user_name }}</div>
            <div class="uemail">{{ ldata.user_email }}</div>
          </div>

          <!-- User Menu -->
          <div v-if="isUserMenuOpen" class="user-menu" @click.stop>
            <!-- <a href="/settings" class="menu-item">
              <i class='bx bx-cog'></i>
              Settings
            </a> -->

            <button class="menu-item danger" @click="logout">
              <i class='bx bx-log-out'></i>
              Logout
            </button>
          </div>

        </div>


      </div>
    </div>
  </header>

  <!-- ================= MOBILE OVERLAY ================= -->
  <div v-if="isMobileMenuOpen" class="mobile-overlay" @click="closeMobileMenu"></div>

  <!-- ================= MOBILE DRAWER ================= -->
  <aside class="mobile-drawer" :class="{ open: isMobileMenuOpen }">
    <!-- Drawer Header -->
    <div class="drawer-header">
      <div class="brand-icon">
        <i class='bx bx-check-shield'></i>
      </div>
      <span class="brand-text">OWNERSHIP</span>
    </div>

    <div class="drawer-divider"></div>

    <!-- Drawer Nav -->
    <nav class="drawer-nav">
      <a v-for="item in nav" :key="item.title" :href="item.path" @click="closeMobileMenu">
        {{ item.title }}
      </a>
    </nav>
  </aside>
</template>

<script>
import { chkPlanApi } from "@/apis/authapis";

  export default {
    name: "MainHeader",

    data() {
      return {
        ldata:null,
        selPage: "",
        isUserMenuOpen: false,
        nav: [
          {
            title: "Dashboard",
            path: "/"
          },
          {
            title: "Audience",
            path: "/audience"
          },
          //  {
          //   title: "Campaigns",
          //   path: "/campaigns"
          // },
          {
            title: "Send Broadcast",
            path: "/send-broadcast"
          },
          {
            title: "Settings",
            path: "/settings"
          }
          
        ],
        plan: {
          name: "Free",
          renewal: ""
        },
        user: {
          avatar: "https://i.pravatar.cc/100"
        },
        isMobileMenuOpen: false
      };
    },
    mounted() {
      const ldataRaw = sessionStorage.getItem("ldata");
      if(ldataRaw!=null && ldataRaw.length>0){
        this.ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
        if(this.ldata!=null){
         
          this.chkPlanNow();
          if((this.ldata.user_type+"").localeCompare("admin")==0){
            this.nav = [
            {
              title: "Dashboard",
              path: "/home1"
            },
            {
              title: "Creators",
              path: "/admin/creators"   // approvals, suspensions, profiles
            },
            {
              title: "Audience Metrics",
              path: "/admin/audience"   // aggregate only, no PII
            },
            {
              title: "Broadcast Monitor",
              path: "/admin/broadcasts" // delivery, failures, abuse detection
            },
            {
              title: "Membership Plans",
              path: "/admin/plans"   // access control, risk, incidents
            },
            {
              title: "Audit Logs",
              path: "/admin/logs"       // approvals, bans, config changes
            },
            
            {
              title: "Settings",
              path: "/admin/settings"   // platform-level configs
            }
          ];

          }
          else if((this.ldata.user_type+"").localeCompare("audience")==0){
            this.nav = [
              {
                title: "Home",
                path: "/home2"
              },
              {
                title: "Following",
                path: "/user/following"
              },
              {
                title: "Profile",
                path: "/user/content"
              },
              {
                title: "Settings",
                path: "/user/settings"
              }
            ];
          }
          else if ((this.ldata.user_type + "").localeCompare("agancy") === 0) {
              this.nav = [
                {
                  title: "Dashboard",
                  path: "/home3"
                },
                // {
                //   title: "Discover Influencers",
                //   path: "/agency/discover"
                // },
                // {
                //   title: "Campaigns",
                //   path: "/agency/campaigns"
                // },
                {
                  title: "Interested",
                  path: "/agency/interested"
                },
                // {
                //   title: "Insights",
                //   path: "/agency/insights"
                // },
                {
                  title: "Settings",
                  path: "/agency/settings"
                }
              ];
          }
        }
      }
      this.selPage = "/" + window.location.pathname.split("/").filter(seg => seg !== "") + "";
      document.addEventListener("click", this.closeUserMenu);
    },
    beforeUnmount() {
      document.removeEventListener("click", this.closeUserMenu);
    },
    methods: {
      beautifyDate(date) {
    if (!date) return "-";

    return new Intl.DateTimeFormat('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).format(new Date(date));
  },
       async chkPlanNow() {

      if (!this.ldata.user_id) return;

      const res = await chkPlanApi(this.ldata.user_id);
       
      if (res && res.status) {

        this.plan.name = res.user_dt.mplan_name;
        this.plan.renewal = this.beautifyDate(res.user_dt.user_membership_expiry);
        // alert(this.plan.name+"");

      }
    },
      gotonoti(){
        window.location.href = "/notifications";
      },
      gotoplans(){
        window.location.href = "/our-plans";
      },
      closeMobileMenu() {
        this.isMobileMenuOpen = false;
      },
      toggleUserMenu(e) {
        e.stopPropagation();
        this.isUserMenuOpen = !this.isUserMenuOpen;
      },

      closeUserMenu() {
        this.isUserMenuOpen = false;
      },

      logout() {
        // Placeholder logout logic
        sessionStorage.clear();
        window.location.href = "/login";
      }
    }
  };
</script>

<style scoped>
  /* ===============================
   HEADER BASE
   =============================== */
  .main-header {
    position: sticky;
    top: 0;
    z-index: 50;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid #f1f5f9;
  }

  .header-inner {
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 24px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  /* ===============================
   LEFT
   =============================== */
  .header-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .menu-btn {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .brand {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .brand-icon {
    width: 36px;
    height: 36px;
    background: #0f172a;
    color: white;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .brand-text {
    font-weight: 800;
    font-size: 15px;
  }

  /* Desktop nav */
  .nav a {
    font-size: 13px;
    font-weight: 700;
    color: #94a3b8;
    margin-left: 24px;
  }

  .nav a.active {
    color: #0f172a;
    position: relative;
  }

  .nav a.active::after {
    content: "";
    position: absolute;
    bottom: -6px;
    left: 0;
    width: 100%;
    height: 2px;
    background: #0f172a;
    border-radius: 2px;
  }

  /* ===============================
   RIGHT
   =============================== */
  .header-right {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .plan-pill {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #f8fafc;
    border: 1px solid #e5e7eb;
    padding: 6px 12px;
    border-radius: 999px;
    font-size: 11px;
  }

  .dot {
    width: 6px;
    height: 6px;
    background: #10b981;
    border-radius: 50%;
  }

  .divider {
    width: 1px;
    height: 12px;
    background: #e5e7eb;
  }

  .icon-btn {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    overflow: hidden;
  }

  .avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  /* ===============================
   MOBILE OVERLAY
   =============================== */
  .mobile-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 40;
  }

  /* ===============================
   MOBILE DRAWER
   =============================== */
  .mobile-drawer {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 280px;
    background: white;
    z-index: 50;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
  }

  .mobile-drawer.open {
    transform: translateX(0);
  }

  .drawer-header {
    padding: 24px;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .drawer-divider {
    height: 1px;
    background: #f1f5f9;
  }

  .drawer-nav {
    padding: 24px;
  }

  .drawer-nav a {
    display: block;
    font-size: 15px;
    font-weight: 600;
    color: #334155;
    padding: 10px 8px;
    border-radius: 8px;
  }

  .drawer-nav a:hover {
    background: #f1f5f9;
  }

  /* ===============================
   MOBILE ONLY
   =============================== */
  @media (max-width: 420px) {
    .brand-text {
      display: none;
    }
  }

  /* ===============================
   MOBILE-ONLY NAV ICON
   =============================== */

  /* Hide menu button by default (desktop) */
  .menu-btn {
    display: none;
  }

  /* Show menu button only on mobile */
  @media (max-width: 768px) {
    .menu-btn {
      display: flex;
    }

    .plan-pill {
      display: none !important;
    }
  }
  /* ===============================
   USER MENU (AVATAR DROPDOWN)
   =============================== */

.user-menu {
  position: absolute;
  top: 48px;
  right: 0;
  width: 180px;
  background: white;
  border-radius: 14px;
  box-shadow: 0 12px 40px rgba(0,0,0,0.12);
  border: 1px solid #f1f5f9;
  z-index: 60;
  overflow: hidden;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  text-decoration: none;
  background: white;
  width: 100%;
}

.menu-item:hover {
  background: #f8fafc;
}

.menu-item .bx {
  font-size: 18px;
}

.menu-item.danger {
  color: #b91c1c;
}
.user-meta {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.uname {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
}

.uemail {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
}
.icon-avatar {
  background: #0f172a;     /* black circle */
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white; /* white outline */
}

.icon-avatar .bx {
  font-size: 20px;
  color: white; /* white icon */
}

</style>